/**
 * Lightweight in-editor dialog — replaces window.alert / confirm.
 */
export default function EditorDialog({
  open,
  title = 'Bilgi',
  message = '',
  confirmLabel = 'Tamam',
  cancelLabel = 'İptal',
  showCancel = false,
  danger = false,
  onConfirm,
  onCancel,
  children,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[12000] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <button
        type="button"
        className="absolute inset-0 bg-black/45 border-0 cursor-default"
        aria-label="Kapat"
        onClick={() => (showCancel ? onCancel && onCancel() : onConfirm && onConfirm())}
      />
      <div className="relative w-full max-w-md rounded-2xl bg-white shadow-2xl border border-gray-200 overflow-hidden">
        <div className="px-5 pt-5 pb-2">
          <h2 className="text-base font-semibold text-gray-900">{title}</h2>
          {message ? (
            <p className="mt-2 text-sm text-gray-600 leading-relaxed whitespace-pre-line">
              {message}
            </p>
          ) : null}
          {children}
        </div>
        <div className="px-5 py-4 flex justify-end gap-2 bg-gray-50 border-t border-gray-100">
          {showCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50"
            >
              {cancelLabel}
            </button>
          )}
          <button
            type="button"
            onClick={onConfirm}
            className={`px-4 py-2 rounded-lg text-sm font-medium text-white ${
              danger ? 'bg-red-600 hover:bg-red-500' : 'bg-[#AE256D] hover:bg-[#B6397A]'
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
